import { IntlFormatters } from 'react-intl'

export const breadcrumb = (intl: IntlFormatters, type?: string) => [
    {
        id: "0",
        label: intl.formatMessage({
            id: 'modals.new.forum.breadcrumbs.forum',
            defaultMessage: 'Forum',
        }),
    },
    {
        id: "1",
        label: intl.formatMessage({
            id: `modals.new.forum.breadcrumbs.create${type ? `.edit.${type}` : ''}`,
            defaultMessage: 'New discussion creation',
        }),
    },
]
